import EmailUpdateAlertController from 'partial/EmailUpdateAlert/EmailUpdateAlertController';

export default EmailUpdateAlertController;
